import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDiamondShine: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconDiamondShine"><Path d="M13.0009 2H11.0009V5H13.0009V2Z" fill="currentColor"/><Path d="M3.63687 3.22177L2.22266 4.63599L4.34398 6.75731L5.75819 5.34309L3.63687 3.22177Z" fill="currentColor"/><Path d="M20.3649 3.22177L21.7791 4.63599L19.6578 6.75731L18.2436 5.34309L20.3649 3.22177Z" fill="currentColor"/><Path d="M7.52026 7L3.52026 12H20.4815L16.4815 7H7.52026Z" fill="currentColor"/><Path d="M12.0009 22.4142L3.58668 14H20.4151L12.0009 22.4142Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDiamondShine;
